import React from 'react'

const Project = () => {
    return (
        <div id='projects'>
            <div className='projects-body' >
                <div className='edu-head' >
                    <img className='project-head' src={require('./images/projects.png')} />
                    <h1 style={{ marginTop: "20px" }} ><b>My <span style={{ color: "#126a60" }} >Projects</span></b></h1>
                </div>
                <div className='projects'>

                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/sociosync.jpeg')} alt="Avatar" class="image"   />
                            <div class="overlay">
                                <h3>Social Media App MERN</h3>
                                <div class="text"><a href='https://sociosync.netlify.app/' target='_blank' > <i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>SocioSync - Social Media App<sup>(live)</sup></a></div>
                                <a href='https://github.com/BhanuPratap0/social-media-app' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px target='_blank'" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>
                                <p>A full-stack social media app built using the MERN stack, featuring comprehensive functionality such as following, liking, messaging, posting, and other features.</p>
                            </div>
                        </div>
                    </div>
                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/promptopia.jpg')} alt="Avatar" class="image"   />
                            <div class="overlay">
                                <h3>Promptopia-Next.js CRUD</h3>
                                <div class="text"><a href='https://promptopia-share-ai.netlify.app/' target='_blank' > <i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>Promptopia<sup>(live)</sup></a></div>
                                <a href='https://github.com/BhanuPratap0/Promptopia--Share-AI-Prompt' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px target='_blank'" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>
                                <p>A Next.js app where you can share your ChatGPT prompts with others and copy theirs.</p>
                            </div>
                        </div>
                    </div>

                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/talk-a-tive.png')} alt="Avatar" class="image" />
                            <div class="overlay">
                                <h3>Chat-App MERN</h3>
                                <div class="text"><a href='https://talk-a-tive-ihk6.onrender.com' target='_blank' ><i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>Talk-A-Tive <sup>(live)</sup></a></div>

                                <a href='https://github.com/BhanuPratap0/Chat-app-final-new' target='_blank' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>

                                <p>Full-Stack Chat-App Built Using MERN Stack And Realtime Chat With The Help Of Socket.IO</p>
                            </div>
                        </div>
                    </div>
                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/inotebook.PNG')} alt="Avatar" class="image" />
                            <div class="overlay">
                                <h3>Notes-App MERN</h3>
                                <div class="text"><a href='https://bhanu-inotebook.netlify.app/' target='_blank' > <i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>iNoteBook <sup>(live)</sup></a></div>
                                <a href='https://github.com/BhanuPratap0/inotebook' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px target='_blank'" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>
                                <p>Full-Stack Notes-App Built Using MERN Stack. Easy To Use And Useful For Day-To-Day Note Making</p>
                            </div>
                        </div>
                    </div>

                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/news.PNG')} alt="Avatar" class="image" />
                            <div class="overlay">
                                <h3>LiveNews-App MERN</h3>
                                <div class="text"><a href='https://newsmonkey-us.netlify.app/' target='_blank' > <i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>News Monkey-US <sup>(live)</sup></a></div>
                                <a href='https://github.com/BhanuPratap0/NewsMonkey-US' target='_blank' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>
                                <p>NewsMonkey-US Is A React App Build With Integration Of Live News API. You Can Access Latest US News Here. </p>
                            </div>
                        </div>
                    </div>
                    <div className='containerx-parent'>
                        <h3></h3>
                        <div class="containerx">
                            <img src={require('./images/text-util.png')} alt="Avatar" class="image" />
                            <div class="overlay">
                                <h3>Text-Utils React-App</h3>
                                <div class="text"><a href='https://my-textutilapp.netlify.app/' target='_blank'> <i class="fa-regular fa-eye" style={{ marginRight: "5px" }} ></i>Text-Utils <sup>(live)</sup></a></div>
                                <a href='https://github.com/BhanuPratap0/Text-Utils' target='_blank' ><div className='button-class' >
                                    <i class="fa-solid fa-code" style={{ color: "#ffffff", marginTop: "5px", marginLeft: "5px", marginRight: "-5px" }}></i>
                                    <button className='btn btn-primary btn-sm mx-1 code-button '>code</button>
                                </div>
                                </a>
                                <p>Text-Utils Is Built Using ReactJs. You Can Play With Your Text Here.</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Project
